import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shivajinagartomumbaicab() {



const cardData = {
  keyword: " Shivajinagar to Mumbai Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Shivajinagar to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Shivajinagar to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is your trusted choice for Shivajinagar to Mumbai cab travel.",

topPlaces: [

  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful destination surrounded by lush greenery, luxury hotels, cafés, and scenic walking paths. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this beautiful location to enjoy boating, lakeside dining, and relaxing evening strolls. It is an ideal spot for families, couples, and anyone looking to unwind in the heart of Mumbai."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is one of Mumbai's most famous beaches, attracting visitors with its lively atmosphere, delicious street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune makes the road journey comfortable for families and groups planning a fun-filled beach outing and a relaxing evening by the Arabian Sea."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site renowned for its stunning Victorian Gothic architecture. Travelers renting an Innova Crysta in Pune can conveniently visit this iconic railway station while exploring nearby heritage buildings, local markets, and historic streets that showcase Mumbai's rich colonial legacy."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Travelers hiring an Innova Crysta on rent in Pune can enjoy breathtaking views of the Bandra-Worli Sea Link, explore the ancient fort walls, and capture memorable photographs from one of Mumbai's most scenic viewpoints."
  },
  
    {
    title: "Elephanta Caves",
    description: "Elephanta Caves is a UNESCO World Heritage Site located on Elephanta Island and is one of Mumbai's most remarkable historical attractions. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive to the Gateway of India before taking a ferry to explore the ancient rock-cut caves. The impressive sculptures, especially the massive Trimurti of Lord Shiva, make it a must-visit destination for history lovers and photographers."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece and an internationally renowned meditation center near Gorai. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore its magnificent golden dome, peaceful meditation halls, and informative museum while enjoying a calm and spiritual experience."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill offer beautifully landscaped gardens, artistic hedges, and panoramic views of Marine Drive. Travelers renting an Innova Crysta in Pune can spend a peaceful afternoon surrounded by greenery while enjoying one of Mumbai's most popular viewpoints overlooking the Arabian Sea."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's busiest shopping streets, offering trendy fashion, antiques, handicrafts, cafés, and local restaurants. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this lively market and enjoy a memorable shopping experience in the heart of South Mumbai."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is one of Mumbai's most sacred temples dedicated to Lord Ganesha. Visitors hiring an Innova Crysta on rent in Pune can conveniently visit this famous spiritual destination to seek blessings while experiencing the temple's peaceful atmosphere and remarkable architecture."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic coastal promenade known for its cool sea breeze, beautiful skyline, and stunning sunset views. Travelers choosing an Innova Crysta on rent in Pune can relax by the waterfront, enjoy leisurely walks, and admire spectacular views of the Arabian Sea and the Bandra-Worli Sea Link."
  }
],



services: [
{
name: "Shivajinagar to Mumbai Innova Crysta",
description: "Shivajinagar to Mumbai Innova Crysta cab service offers premium SUV transportation between Pune and Mumbai. The Innova Crysta provides spacious seating, comfortable interiors, and smooth highway performance suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup from homes, offices, hotels, and Shivajinagar railway station. Ideal for corporate travel, airport transfers, and family trips."
},
{
name: "Pune Station to Mumbai Cab Service",
description: "Pune Station to Mumbai cab service provides reliable transportation for travelers arriving at Pune Railway Station. Comfortable vehicles with professional drivers ensure safe expressway travel to Mumbai. Pickup services are available directly from the railway station platforms or nearby hotels. Flexible booking options allow convenient cab reservations."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service offers convenient travel options for passengers planning same-day or multi-day return journeys. Comfortable sedan and SUV vehicles ensure smooth highway travel via the Mumbai–Pune Expressway. Professional drivers provide safe driving and punctual pickup services across Pune."
},
{
name: "Bund Garden to Mumbai Cab",
description: "Bund Garden to Mumbai cab service provides reliable transportation between Pune’s Bund Garden area and Mumbai city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Yerwada to Mumbai Cab Service",
description: "Yerwada to Mumbai cab service offers dependable transportation between Pune’s Yerwada area and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway journeys for business trips and family travel."
},
{
name: "Camp to Mumbai Cab Service",
description: "Camp to Mumbai cab service provides reliable intercity transportation from Pune Camp area to Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Wakdewadi to Mumbai Cab",
description: "Wakdewadi to Mumbai cab service offers convenient transportation for passengers traveling from Wakdewadi in Pune to Mumbai. Comfortable vehicles and professional drivers ensure safe and timely journeys."
},
{
name: "Khadki to Mumbai Cab Service",
description: "Khadki to Mumbai cab service provides dependable transportation between Pune’s Khadki area and Mumbai city. Vehicles are suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Swargate to Mumbai Cabs",
description: "Swargate to Mumbai cab service offers reliable transportation between Pune’s Swargate area and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation suitable for families and small groups. The Ertiga vehicle provides comfortable seating and luggage capacity for long-distance highway travel."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for passengers seeking comfortable highway travel. Spacious interiors and smooth driving performance make Innova ideal for long-distance journeys."
},
{
name: "Cab Service in Shivaji Nagar Pune",
description: "Cab service in Shivaji Nagar Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe rides across Shivaji Nagar and nearby Pune areas."
},
{
name: "Shivajinagar to Dadar Cab Service",
description: "Shivajinagar to Dadar cab service provides dependable transportation between Pune and Mumbai’s Dadar area. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Shivaji Nagar to Andheri Cab Service",
description: "Shivaji Nagar to Andheri cab service offers convenient transportation between Pune and Andheri in Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Pune Station to Mumbai Cab",
description: "Pune Station to Mumbai cab service provides quick and reliable transportation for passengers arriving at Pune Railway Station. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai provides reliable intercity transportation with comfortable vehicles and professional drivers. The service ensures safe expressway travel, punctual pickup, and flexible booking options."
},
{
name: "Innova Crysta on Rent in Shivaji Nagar Pune",
description: "Innova Crysta on rent in Shivaji Nagar Pune offers premium SUV rental for travelers seeking spacious and comfortable transportation. Ideal for family trips, airport transfers, and corporate travel."
},
{
name: "Ertiga on Rent in Shivaji Nagar",
description: "Ertiga on rent in Shivaji Nagar provides spacious SUV transportation suitable for families and small groups. The vehicle offers comfortable seating and smooth highway travel performance."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune offers dependable transportation services for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and smooth rides."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and long-distance journeys. Comfortable vehicles and experienced drivers ensure safe travel across Pune."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading from Pune to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Cab Service in Shivaji Nagar Station",
description: "Cab service in Shivaji Nagar station provides reliable taxi services for passengers arriving at or departing from Shivajinagar railway station. Comfortable vehicles and professional drivers ensure quick and safe transportation."
},
{
name: "Shivajinagar to Mumbai Cab",
description: "Shivajinagar to Mumbai cab service provides reliable intercity transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Shivajinagar to Mumbai Taxi",
description: "Shivajinagar to Mumbai taxi service offers convenient transportation for travelers heading from Pune to Mumbai city. Vehicles are comfortable and suitable for highway travel."
},
{
name: "Shivajinagar to Mumbai Cab Service",
description: "Shivajinagar to Mumbai cab service offers dependable transportation between Pune and Mumbai with professional drivers ensuring safe journeys via the expressway."
}
],

tableData: [
["Shivajinagar to Mumbai Innova Crysta","Pune Station to Mumbai Cab Service"],
["Pune to Mumbai Cab Round Trip","Bund Garden to Mumbai Cab"],
["Yerwada to Mumbai Cab Service","Camp to Mumbai Cab Service"],
["Wakdewadi to Mumbai Cab","Khadki to Mumbai Cab Service"],
["Swargate to Mumbai Cabs","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Cab Service in Shivaji Nagar Pune"],
["Shivajinagar to Dadar Cab Service","Shivaji Nagar to Andheri Cab Service"],
["Pune Station to Mumbai Cab","Best Cab Service Pune to Mumbai"],
["Innova Crysta on Rent in Shivaji Nagar Pune","Ertiga on Rent in Shivaji Nagar"],
["Velocity Cabs Pune","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Pune Mumbai Cab"],
["Cab Service in Shivaji Nagar Station","Shivajinagar to Mumbai Cab"],
["Shivajinagar to Mumbai Taxi","Shivajinagar to Mumbai Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Shivajinagar to Mumbai through the Mumbai Pune Expressway. Their familiarity with highway routes and city traffic ensures safe, smooth, and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Shivajinagar to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Shivajinagar to Mumbai cab service operates 24 hours a day. Whether you need an early morning ride, corporate travel, or late night drop, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Shivajinagar to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Shivajinagar",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and commercial locations across Shivajinagar and nearby areas like Deccan, JM Road, FC Road, and Model Colony."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Shivajinagar to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Shivajinagar to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Shivajinagar to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Shivajinagar to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Shivajinagar to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Shivajinagar to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Shivajinagar and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and railway stations across Shivajinagar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Shivajinagar to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Deshpande",
    feedback:
      "Shivajinagar to Mumbai cab service with Velocity Cab was very comfortable and smooth. The AC vehicle was clean, and the ride was pleasant throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Shivajinagar to Mumbai AC cab experience with Velocity Cab was excellent. The ride was punctual, well-maintained, and very relaxing even for a long trip.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shivajinagar to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Shivajinagar to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Andheri, Pune Station, Bund Garden, Yerwada, Camp, Wakdewadi, Khadki, and Swargate. Enjoy safe, comfortable, and punctual rides with easy online booking from Shivajinagar to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Shivajinagar to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Shivajinagar to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Andheri, Pune Station, Bund Garden & more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Shivajinagartomumbaicab;